import type { Ref } from 'react';
import * as React from 'react';
import { forwardRef, useMemo } from 'react';
import type { ToggleButtonGroupProps } from '@components/moleculs/toggle-button-group/types';
import { ToggleButton } from '@mui/material';
import cn from 'classnames';

import { ToggleButtonGroupStyled } from './styles';

export const ToggleButtonsGroupComponent = forwardRef(
    <T extends NonNullable<unknown>, Multiple extends undefined | boolean>(
        props: ToggleButtonGroupProps<T, Multiple>,
        ref: Ref<HTMLSelectElement>,
    ) => {
        const {
            className,
            required,
            fieldState,
            helperText,
            disabled,
            options,
            multiple,
            ...rest
        } = props;
        const errorText = useMemo(() => {
            if (fieldState?.error?.message) {
                return fieldState.error.message;
            }

            return '';
        }, [fieldState]);

        return (
            <ToggleButtonGroupStyled
                color='primary'
                className={cn(className, {
                    'Mui-error-container': !!errorText,
                })}
                ref={ref}
                disabled={disabled}
                exclusive={!multiple}
                {...rest}
            >
                {options?.map((item) => (
                    <ToggleButton value={item.value} key={item.value as unknown as string}>
                        {item.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroupStyled>
        );
    },
);

export const ToggleButtonGroup = ToggleButtonsGroupComponent as <
    T extends NonNullable<unknown>,
    Multiple extends undefined | boolean,
>(
    props: ToggleButtonGroupProps<T, Multiple> & { ref?: Ref<HTMLSelectElement> },
) => React.ReactElement;
